<script setup>
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import GlobalHero from '@sections/global/Hero.vue'
import ContactForm from '@sections/contact/ContactForm.vue'

const global = useGlobalStore()

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'contact')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'contact')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'contact')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<main>
		<GlobalHero :rive="{ src: 'https://cdn.papercrowns.com/website/rive/lockups/contact.riv', height: 512, width: 512 }" titleSvg="https://cdn.papercrowns.com/website/images/elements/lockups/contact-us-alt.svg" />
		<ContactForm />
	</main>
</template>
